import ColorHash from "color-hash";

export const serverNameFull = window.location.hostname;
export const serverNameShort = serverNameFull.split(".", 1)[0];
export const serverColorBg = new ColorHash({ lightness: 0.15, saturation: 0.25 }).hex(serverNameFull);

export const ExchangeType = {
  POLONIEX: "POLONIEX",
  BINANCE: "BINANCE",
  BITTREX: "BITTREX",
  BINANCE_FUTURES: "BINANCE_FUTURES",
  BINANCE_FUTURES_TEST: "BINANCE_FUTURES_TEST",
};



// WEBPACK FOOTER //
// ./src/constants.js